import React from 'react';

import { useEffect, useState } from "react";
import "./Services.css";

import car1 from "../../assets/images/Car1.png";
import car2 from "../../assets/images/Car2.png";
import car3 from "../../assets/images/Car3.png";
import car4 from "../../assets/images/Car4.png";
import car5 from "../../assets/images/Car5.png";
import car6 from "../../assets/images/Car6.png";

export const Services = () => {
  const carImages = [car1, car2, car3, car4, car5, car6];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carImages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [carImages.length]);

  return React.createElement(
    "section",
    { className: "services", id: "services" },
    React.createElement(
      "div",
      { className: "header-text" },
      React.createElement("h4", null, "Our Services"),
      React.createElement(
        "h3",
        null,
        "We Ensure the Best ",
        React.createElement("span", null, "Customer Experience")
      )
    ),
    React.createElement(
      "div",
      { className: "features" },
      // Left Features Column
      React.createElement(
        "div",
        { className: "features-column" },
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-money-rupee-circle-fill" })
          ),
          React.createElement("h4", null, "Affordable Performance Parts")
        ),
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-wallet-3-fill" })
          ),
          React.createElement("h4", null, "Value for Every Budget")
        ),
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-bank-card-fill" })
          ),
          React.createElement("h4", null, "Flexible Ordering & Payment Options")
        )
      ),

      // Center Image
      React.createElement(
        "div",
        { className: "service-image" },
        React.createElement("img", {
          src: carImages[currentImageIndex],
          alt: "Car",
        })
      ),

      // Right Features Column
      React.createElement(
        "div",
        { className: "features-column" },
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-medal-fill" })
          ),
          React.createElement("h4", null, "Premium Quality Assurance")
        ),
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-user-star-fill" })
          ),
          React.createElement("h4", null, "Expert-Trusted Components")
        ),
        React.createElement(
          "div",
          { className: "feature-item" },
          React.createElement(
            "div",
            { className: "sicon" },
            React.createElement("i", { className: "ri-taxi-wifi-fill" })
          ),
          React.createElement("h4", null, "Seamless Global Delivery")
        )
      )
    )
  );
};
